import React, {useCallback, useEffect} from 'react';
import i18n from '../../../../../i18n';
import Panel from '../../../../../components/Panel';

import {useDispatch, useSelector} from 'react-redux';
import {layoutActions, layoutSelectors} from '../../../redux';
import {Trans} from 'react-i18next';
import FormikCheckbox from '../../../../../components/inputs/FormikCheckbox';
import LastUpdatedLabel from '../../../../../components/LastUpdatedLabel';
import {IPasswordData, PasswordData} from 'types/PasswordData';
import FormikDropdown from '../../../../../components/inputs/FormikDropdown';
import {enums} from 'types/enums';
import FormikNumberField from '../../../../../components/inputs/FormikNumberField';
import {FormFooterButtons} from 'components/buttons/FormFooterButtons';
import {Grid} from '@mui/material';
import Formik, {FormOnSubmitHelpers} from 'components/hook-form/Formik';
import {ReactFChildrenProps} from 'types/react/ReactFChildrenProps';

type PasswordPoliciesProps = {};

export const PasswordPolicies: ReactFChildrenProps<PasswordPoliciesProps> = (props) => {
   const dispatch = useDispatch();
   const passwordData = useSelector(layoutSelectors.passwordData);

   useEffect(() => {
      dispatch(layoutActions.getPasswordData);
   }, [dispatch]);

   const submit = useCallback(
      (passwordData: IPasswordData, formikBag: FormOnSubmitHelpers<IPasswordData>) => {
         dispatch(
            layoutActions.postPasswordData(passwordData, {
               onSuccess: () => {
                  formikBag.setSubmitting(false);
                  dispatch(layoutActions.getPasswordData);
               },
               onError: (errors: any) => formikBag.setErrors(errors),
            })
         );
      },
      [dispatch]
   );

   return (
      <Panel name={i18n.t('Password Policies')}>
         <Formik
            initialValues={PasswordData.cast(passwordData) as IPasswordData}
            validationSchema={PasswordData}
            enableReinitialize
            onSubmit={submit}
         >
            <>
               <Grid container spacing={3}>
                  <Grid item sm={12} lg={6}>
                     <FormikDropdown
                        name="passwordUpdateInterval"
                        placeholder={i18n.t('Minimum password change frequency')}
                        options={enums.passwordUpdateInterval.options}
                     />
                  </Grid>
               </Grid>
               <Panel name={i18n.t('Password Format')}>
                  <Grid container spacing={3}>
                     <Grid item sm={12} lg={5}>
                        <FormikNumberField
                           name="minNumChars"
                           placeholder={i18n.t('Minimum number of characters')}
                        />
                     </Grid>
                  </Grid>
                  <Grid container spacing={3}>
                     <Grid item>
                        <FormikCheckbox
                           name="mixedCaseRequired"
                           label={i18n.t(
                              'Passwords must contain both uppercase and lowercase letters'
                           )}
                        />
                     </Grid>
                  </Grid>
                  <Grid container spacing={3}>
                     <Grid item>
                        <FormikCheckbox
                           name="alphaNumericRequired"
                           label={i18n.t(
                              'Passwords must contain both alpha and numeric characters'
                           )}
                        />
                     </Grid>
                  </Grid>
                  <Grid container spacing={3}>
                     <Grid item>
                        {' '}
                        <FormikCheckbox
                           name="specialCharsRequired"
                           label={
                              <>
                                 <Trans>
                                    Passwords must contain at least 1 special character. Allowable
                                    special characters are
                                 </Trans>
                                 : <br />
                                 {
                                    '!  "  #  $  %  &  \'  (  )  *  +  ,  -  .  /  :  ;  <  =  >  ?  @  [  \\  ]  ^  _  `  {  |  }  ~'
                                 }
                              </>
                           }
                        />
                     </Grid>
                  </Grid>
                  <Grid container spacing={3}>
                     <Grid item>
                        <b>NOTE: </b>&nbsp; Format changes do not affect existing passwords and will
                        be used to validate new passwords only.
                     </Grid>
                  </Grid>
               </Panel>
               <Grid container spacing={3}>
                  <Grid item>
                     <LastUpdatedLabel
                        date={passwordData.timestamp}
                        author={passwordData.lastUser}
                     />
                  </Grid>
               </Grid>
               <Grid container spacing={3} justifyContent="center">
                  <Grid item>
                     <FormFooterButtons submitLabel={i18n.t('Save')} resettable />
                  </Grid>
               </Grid>
               {/* {JSON.stringify(formikProps.values)} */}
            </>
         </Formik>
      </Panel>
   );
};
